const TEXT = {
  WELCOME_TO_ICERTIS: "Welcome to Icertis",
  ADD_TO_ICI: "Add to ICI",
  ATTACH_FROM_ICI: "Attach from ICI",
  EMAIL_THREAD: "Email Thread",
  FILE_FORMAT: "File Format",
  DRAG_AND_DROP_EMAILS_TO_AGREEMENT_ASSOCIATION: "Drag and Drop emails to add as  Agreement Association",
  MSG: ".msg",
  DOCX: ".docx",
  SAVED_SEARCH: "Saved Search",
  NO_AGREEMENTS_FOUND: "No Agreements Found",
  NO_ASSOCIATION_FOUND: "No Associations Found",
  NO_SAVED_SEARCHES_FOUND: "No Saved Searches Found",
  PLACEHOLDER_SAVED_SEARCH: "Select Saved Search",
  PLACEHOLDER_SEARCH_AGREEMENTS: "Search Agreements",
  LOADING_AGREEMENTS: "Loading Agreements",
  LOADING_ASSOCIATIONS: "Loading Associations",
  LOADING_SAVED_SEARCHES: "Loading Saved Searches",
  END_OF_THE_AGREEMENT_LIST: "End of the Agreement List",
  NAME: "Name",
  CREATED_BY: "Created by",
  AGREEMENT_CODE: "Agreement Code",
  STATUS: "Status",
  ADVANCED_ADD_TO_ICI: "Advanced: Add to ICI",
  ADVANCED_ADD_OPTIONS: "Advanced Add Options",
  LOADING_AGREEMENT_DETAILS: "Loading Agreement Details",
  FORMAT: "Format",
  ADD_TO_LOCATION: "Add to Location",
  PLACEHOLDER_SELECT_LOCATION: "Select Location",
  NEW_DOCUMENT: "New document",
  REPLACE_EXISTING: "Replace existing",
  ASSOCIATED_DOCUMENTS: "Associated Documents",
  NAME_OF_DOCUMENT: "Name of document",
  NO_ASSOCIATION_INSTANCES_FOUND: "No Association Instances Found",
  END_OF_THE_ASSOCIATION_INSTANCES_LIST: "End of the Association Instances List",
  LOADING_ASSOCIATION_INSTANCES: "Loading Association Instances",
  AGREEMENT_NEW_VERSION: "Agreement (new version)",
  NO_LOCATIONS_FOUND: "No Locations Found",
  UPLOADING_TO_ICI: "Uploading to ICI",
  UPLOADED_TO_ICI_SUCCESSFULLY: "Uploaded to ICI Successfully",
  UPLOAD_TO_ICI_FAILED: "Upload to ICI Failed",
  ERROR_LOADING_SAVED_SEARCHES: "Error Loading Saved Searches",
  ERROR_LOADING_AGREEMENTS: "Error Loading Agreements",
  ERROR_LOADING_ASSOCIATIONS: "Error Loading Associations",
  ERROR_LOADING_AGREEMENT_DETAILS: "Error Loading Agreement Details",
  ERROR_LOADING_ASSOCIATION_INSTANCES: "Error Loading Association Instances",
  ERROR_LOADING_CTS_BY_SISID: "Error Loading Contract Type",
  ERROR_UPLOAD_DOCUMENT: "Error Upload Document",
  MSG_REQUEST_NAME: "Email as Outlook format.msg",
  MSG_REQUEST_LABEL: "Email as Outlook format (.msg)",
  MSG_REQUEST_TOOLTIP: "Upload this email with attachments in outlook format",
  DOCX_REQUEST_NAME: "Email as Outlook format.docx",
  DOCX_REQUEST_LABEL: "Email as document (.docx)",
  DOCX_REQUEST_TOOLTIP: "Upload this email without attachments in document format",
  PROGRESS_MESSAGE: "Please sideload your addin to see app body.",
  OUTLOOK_TITLE: "Icertis Outlook Add In",
  ATTACH_DOCUMENT_TO_EMAIL: "Attach Document To Email",
  NO_ASSOCIATEDDOC: "No Associated Document Found",
  DOCUMENT_ATTACHED: "Document(s) attached to email",
  PLACEHOLDER_SEARCH_ASSOCIATIONS: "Search Associations",
  CANCEL: "Cancel",
  SELECT: "Done",
  MODAL_HEADER: "Select Association to Replace",
  SHOW_MORE: "Show More",
  RETRY: "Retry",
  UPLOAD_SIZE_WARNING: "Upload size for Drag and Drop exceeds the size limit of ",
  EMAILS_UPLOADED_TO_ICI_SUCCESSFULLY: "email(s) uploaded to ICI successfully",
  EMAILS_ALREADY_UPLOADED_TO_ICI_SUCCESSFULLY: "email(s) already exist in ICI",
  EMAIL_ALREADY_UPLOADED_TO_ICI_SUCCESSFULLY: "Email already exist in ICI",
  EMAILS_FAILED_TO_BE_UPLOADED_TO_ICI: "email(s) failed to be uploaded to ICI",
  ATTACHMENTS_UPLOADED_TO_ICI_SUCCESSFULLY: "attachment(s) uploaded to ICI successfully",
  ATTACHMENTS_FAILED_TO_BE_UPLOADED_TO_ICI: "attachment(s) failed to be uploaded to ICI",
  BYTES: " bytes",
  MB: " MB",
  LOGIN_AUTH_FAIL: "User has no admin privileges, Please contact your Administrator.",
  MEETING_INVITE_EMAIL_VALIDATION: "Meeting Invite Email(s) cannot be uploaded to ICI",
  ACTUAL_AGREEMENT_NEW_VERSION_EXCEPTION_MESSAGE:
    "This appears to be an older version of the document. To access all versions of the document select 'No' and go to the Version History tab.",
  EXPECTED_AGREEMENT_NEW_VERSION_EXCEPTION_MESSAGE: "This appears to be an older version of the document.",
  FORBIDDEN_WARNING: "You do not have enough permissions. Please contact your Administrator.",
  FILE_EXTENSION_NOT_SUPPORTED: "Attachment file format is not supported for upload to ICI.",
  LOCAL_STORAGE_VALIDATION_MSG_KEY: "validationMessages",
  DRAG_AND_DROP_EMAILS_TO_ADD_TO_ICI: "Drag and drop emails to add to ICI.",
  VIEW: "View",
  DOCUMENT_FOLDERS: "Document Folders",
  UPLOADED_EMAIL_FILE_FORMAT: "Uploaded Email File Format",
  OUTLOOK_MESSAGE: "Outlook Message (.msg)",
  MS_WORD_MESSAGE: "MS Word (.docx)",
  LOADING_FOLDERS: "Loading Folders",
  NO_FOLDERS_FOUND: "No Folders Found",
  ASSOCIATED_DOCUMENT: "Associated Document",
  DOCUMENT_LOCATION: "Document Location",
  PLACEHOLDER_ASSOCIATED_DOCUMENT_TYPE: "Select Associated Document Type",
  ASSOCIATED_DOCUMENT_TYPE: "Associated Document Type",
  NO_FILES_FOUND: "No Files Found",
  LOADING_FILES: "Loading Files",
  SELECT_FOLDER_ABOVE: "Please select the folder from above list",
  MSG_ACCESS_TOKEN: "MSGraphAccessToken",
  MSG_REFRESH_TOKEN: "MSGraphRefreshToken",
  USER_EMAIL_ID: "UserEmailId",
  LOADING: "Loading...",
  MORE_INFORMATION: "More Information",
  HIDE_INFORMATION: "Hide Information",
  ATTACHMENT_OPTIONS: "Attachment Options",
  ADD_ATTACHMENTS_FROM_EMAILS: "Add Attachments from Emails",
  GET: "get",
  POST: "post",
  NO_FOLDER_STRUCTURE_CONFIGURED: "no folder structure configured",
  KEEP_BOTH: "Keep Both",
  SKIP: "Skip",
  SUBJECT: "Subject",
  ALREADY_EXISTS_IN: "Already exists in",
  CLEAR: "Clear",
  SEARCH: "Search",
  LOADING_ATTRIBUTES: "Loading Attributes",
  NO_ATTRIBUTES_FOUND: "No Attributes Found",
  END_OF_THE_ATTRIBUTE_LIST: "End of the Attribute List",
  PLACEHOLDER_SEARCH_ATTRIBUTES: "Filter Attributes",
  SEARCH_ONLY_IN: "Search only in",
  WARNING_MULTIPLE_DND_ON_INSTANCES: "Multiple email threads drag and drop is not allowed on Instances",
  LOADING_FOLDER_INSTANCES: "Loading Folder Instances",
  NO_FOLDER_INSTANCES_FOUND: "No Folder Instances Found",
  SUCCESS: "Success",
  FAILURE: "Failure",
  FAILED: "Failed",
  ALREADY_UPLOADED: "Already Uploaded",
  NO_DEFAULT_ASSOCIATION: "No default association is configured for the agreement",
  ADD_EMAIL: "Add Email",
  SUCCESSFULLY_UPLOADED_EMAIL_THREAD: "Successfully uploaded to ",
  UPLOAD_FAILED_EMAIL_THREAD: "Upload failed to ",
  DOT: ".",
  GETTING_DETAILS: "Getting Details",
  ATTACHMENTS: "Attachments",
  ASSOCIATION_TOGGLE: "Specify different type/location for all attachments",
  LOGIN: "Login",
  LOGOUT_CONFIRMATION_MESSAGE: "Are you sure you want to logout?",
  YES: "Yes",
  NO: "No",
  SIGN_OUT: "Sign Out",
  IDP_ACCESS_TOKEN: "idpAccessToken",
  IDP_REFRESH_TOKEN: "idpRefreshToken",
  IDP_ID_TOKEN: "idpIdToken",
  IDP_EXPIRES_IN: "idpExpiresIn",
  VERSION_LABEL: "Version Label",
  NO_LABEL: "No Label",
  SELECT_LABEL: "Select Label",
  DEFAULT_MAJOR_VERSION_TEXT: "Upload as a Major Version",
  MAJOR_MINOR_VERSION_KEY: "Core.DocumentVersion.Configuration",
  VERSION_LABEL_KEY: "EnableDocumentVersionLabels",
  ENTER: "Enter",
  ENTER_KEY_CODE: 13,
  ESCAPE_KEY_CODE: 27,
  ESCAPE: "Escape",
  SETTINGS: "Settings",
  LEFT: "Left",
  RIGHT: "Right",
  REDEYE: "RedEye",
  TEXTDOCUMENT: "TextDocument",
  PREFIX_FOR_LOGS: "logs-outlook-add-in",
  CALLED_FROM_FUNCTION: "called from function",
  CALLED_FROM_API: "called from api",
  ERROR: "LogError",
  STRING: "string",
  UNKNOWN_ERROR: "Unknown Error",
  ERROR_STACK: "Error Stack",
  NAME_LOGS: "name",
  MESSAGE: "message",
  RESPONSE_ITEMS_EMPTY: "Response items as empty array.",
  INFORMATION: "LogInformation",
  WARNING: "LogWarning",
  AUTH_CODE: "auth_code",
  ENABLE_ADVANCE_PAGE: "Enable",
  ADVANCE_PAGE: "Advanced Add Options",
  GO_TO_ADVANCE_PAGE: "Advanced Add Options",
  ADVANCE_PAGE_ADD_TO_ICI: "To add email as associations in ICI, click Advanced Add Options next to the agreement.",
  ICM_REFRESH_TOKEN: "icmRefreshToken",
  ICM_EXPIRES_IN: "icmExpiresIn",
  BANNER_MESSAGE: "Drag and drop is not supported in New Outlook.",
  UPLOAD_FAILED_TEAM_SCENARIO: "You are either not a valid administrator or have not logged in",
  UPLOAD_FAILED_ALLOW_MULTIPLE_INSTANCE_SCENARIO:
    "There can only be one association of this type created for this parent agreement.",
  ACTION_VALIDATOR_ERROR_CODE: 0,
  MISSING_CONFIGURATION_VALUE: "MissingConfigurationValidation",
  ERROR_PREVIEW_DOCUMENT: "An error occurred when previewing document.",
  LOADING_PDF: "Loading PDF...",
};

export { TEXT };
